import { flatMap } from 'lodash-es';

export const reorderItemList = <T>(
  itemList: T[],
  { oldPosition, newPosition }: { oldPosition: number; newPosition: number },
): T[] => {
  if (
    oldPosition < 0 ||
    newPosition < 0 ||
    oldPosition >= itemList.length ||
    newPosition >= itemList.length
  ) {
    throw new Error(
      `reorderItemList: out of range: oldPosition:${oldPosition}, newPosition:${newPosition}`,
    );
  }
  if (oldPosition === newPosition) {
    return itemList;
  }
  const itemToMove = itemList[oldPosition];

  return flatMap(itemList, (p, index) => {
    if (oldPosition === index) {
      return [];
    }
    if (newPosition !== index) {
      return p;
    }
    return newPosition > oldPosition ? [p, itemToMove] : [itemToMove, p];
  });
};
